import { logError } from 'commons/logger';

const safeStringify = (value: unknown) => {
  try {
    return JSON.stringify(value ?? {});
  } catch (error) {
    logError('Error stringifying context', error, {
      value,
    });
    return '';
  }
};

export { safeStringify };
